import { render, staticRenderFns } from "./Daphne.vue?vue&type=template&id=6c2104bd&scoped=true&"
import script from "./Daphne.vue?vue&type=script&lang=js&"
export * from "./Daphne.vue?vue&type=script&lang=js&"
import style0 from "./Daphne.vue?vue&type=style&index=0&id=6c2104bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2104bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
